import { createAsyncThunk } from '@reduxjs/toolkit';
import logger from '@allmysons/utils/logger';
import { MyThunkApiConfig } from '../../types';

export const getBranchListAction = createAsyncThunk<any[], { graphqlFunction: () => Promise<any[]> }, MyThunkApiConfig>(
  'job/branchList',
  async (inputData, { rejectWithValue }) => {
    const { graphqlFunction } = inputData;
    try {
      const response: any[] = await graphqlFunction();
      const sortedBranches = response.sort((a, b) => a.name.localeCompare(b.name));
      return sortedBranches;
    } catch (error) {
      logger.error(error);
      return rejectWithValue({ error: error.message });
    }
  },
);
